
(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npCommonGrid', function () {
        return {
            restrict: 'E',
            transclude: true,
            controller: ['$scope', '$state', '$timeout', '$filter', 'localStorageService', 'browserService', controller],
            controllerAs: 'vm',
            templateUrl: '/app/shared/grid/commonGrid.html',
            scope: {
                data: '=',
                gridSetting: '=',
                notFixHeightRow: '=',
                hiddencheck: '=',
                rowCss: '=',
                maxHeight: '=',
                identifier: '@',
                wrapText: '=',
                onSelectRow: '&onSelectRow',
                onDoubleClick: '&onDoubleClick',
                gridSettingKey: '@',
                columnNotRemove: '=',
                hiddenShowAll: '=',
                showCheckboxOnProperty: '@',
                onRowClick: '&onRowClick',
                notUpperHeader: '=',
                isTotalTitle: '=',
                isProcess: '=',
                loadSize:'='
            },
            link: function (scope, element, attrs, ctrl, transclude) {
                transclude(scope, function (clone) {
                    element.append(clone);
                });

                if (scope.showCheckboxOnProperty != null) {
                    scope.$watch('data', function (data, old) {
                        if (data != null) {
                            var numberOfHiddenCheckboxes = 0;
                            for (var i = 0; i < data.length; i++) {
                                if (!data[i][scope.showCheckboxOnProperty]) {
                                    numberOfHiddenCheckboxes++;
                                }
                            }

                            if (numberOfHiddenCheckboxes == data.length) {
                                scope.hideAllCheckboxes = true;
                            } else {
                                scope.hideAllCheckboxes = false;
                            }
                        }
                    });
                }
            }
        };
    });

    function controller($scope, $state, $timeout, $filter, localStorageService, browserService) {
        var vm = this;
        vm.translation = globalResources;
        vm.columnsDefinition = [];//$scope.gridSetting;
        vm.commonGridSetting = [];//angular.copy(calculateColumnsWidth());
        vm.onRowClick = onRowClick;
        vm.onDoubleClick_ = function (row) {
            $scope.onDoubleClick({ row: row });
        };
        vm.data = arrayCopy($scope.data);
        vm.originalData = arrayCopy($scope.data);
        vm.selectRow = selectRow;
		vm.showColumnInformation = false;
		$scope.reverse = true;
        $scope.currentRowIndex = 0;
        $scope.total = vm.data != null ? vm.data.length : 0;
        $scope.rowCollection = [];
        $scope.showAllDocuments = showAllDocuments;
        vm.BROWSER_TYPE = BrowserType;
        vm.browserType = browserService.detectBrowserWindow();

        $scope.selectedColumn = { order: 'descending', key: '' };
        $scope.times = 0;
        $scope.originalCollection = [];
        vm.showSortIcon = true;
        vm.totalTitle = $scope.isTotalTitle ? vm.translation.Total : vm.translation.TotalNumberDocument;
        vm.isProcess = $scope.isProcess ? true : false;

        var orderBy = $filter('orderBy');

        var infiniteScrollLoadsize = $scope.loadSize;
        if (!infiniteScrollLoadsize) {
            infiniteScrollLoadsize = (HandbookConfiguration.InfiniteScrollLoadSize == "0" || HandbookConfiguration.InfiniteScrollLoadSize == 0) ? 0 : parseInt(HandbookConfiguration.InfiniteScrollLoadSize);
        }

        $scope.initialize = function () {
            getSettingGridColumn();
        };

        function getSettingGridColumn() {
            vm.columnsDefinition = $scope.gridSetting;
            if ($scope.gridSettingKey) {
                var localStorage = localStorageService.getItem($scope.gridSettingKey);
                if (localStorage != undefined) {
                    var objectLocalStorage = JSON.parse(localStorage);
                    vm.columnsDefinition = objectLocalStorage;
                    for (var i = 0; i < $scope.gridSetting.length; i++) {
                        vm.columnsDefinition[i].name = $scope.gridSetting[i].name;
                    }

                }
            }
            vm.commonGridSetting = angular.copy(calculateColumnsWidth());
            vm.showColumnInformation = false;
            vm.commonGridSetting.forEach(function (item) {
                if (item.id == 'information' && item.coldefault) {
                    vm.showColumnInformation = true;
                }
            });
        };

        var lastStart = 0;
        $scope.nextPage = function getData(tableState) {
            if (infiniteScrollLoadsize == 0) {
                $scope.rowCollection = vm.data;
                $scope.originalCollection = arrayCopy($scope.rowCollection);
            } else {
                //if we reset (like after a search or an order)
                if (tableState.pagination.start === 0) {
                    if ($scope.rowCollection == null || $scope.rowCollection.length == 0) {
                        $scope.rowCollection = getAPage();
                        $scope.originalCollection = arrayCopy($scope.rowCollection);
                    }
                } else {
                    //we load more
                    $scope.rowCollection = $scope.rowCollection.concat(getAPage());
                    $scope.originalCollection = arrayCopy($scope.rowCollection);
                    $scope.$apply();
                }

                lastStart = tableState.pagination.start;
            }
        };

		$scope.order = function (predicate, type) {
			$scope.reverse = !$scope.reverse;
			var reverse = $scope.reverse;
            if (predicate == $scope.selectedColumn.key || $scope.selectedColumn.key == "") { // Click header more than one time
                $scope.times += 1;
            } else { // Click another column
                $scope.times = 1;
            }
            $scope.selectedColumn.key = predicate;
            $scope.selectedColumn.order = reverse ? 'descending' : 'ascending';
            if ($scope.times > 2) {
                vm.showSortIcon = false;
				vm.data = arrayCopy(vm.originalData);
				$scope.reverse = !$scope.reverse;
                $scope.times = 0;
            } else {
                switch (type) {
                    case COLUMN_DATA_TYPES.STRING_DATE_TIME:
                        vm.data.sort(function (x, y) {
                            var d1 = Utils.ToDateTime(x[predicate]);
                            var d2 = Utils.ToDateTime(y[predicate]);
                            if (reverse) {
                                return d1 > d2 ? -1 : (d1 == d2 ? 0 : 1);
                            } else {
                                return d1 > d2 ? 1 : (d1 == d2 ? 0 : -1);
                            }
                        });
                        break;
                    case COLUMN_DATA_TYPES.STRING_DATE:
                        vm.data.sort(function (x, y) {
                            var d1 = Utils.ToDate(x[predicate]);
                            var d2 = Utils.ToDate(y[predicate]);
                            if (reverse) {
                                return d1 > d2 ? -1 : (d1 == d2 ? 0 : 1);
                            } else {
                                return d1 > d2 ? 1 : (d1 == d2 ? 0 : -1);
                            }
                        });
                        break;
                    default:
                        vm.data = orderBy(vm.originalData, predicate, reverse);
                        break;
                }
                vm.showSortIcon = true;
            }
            $scope.rowCollection = vm.data.slice(0, $scope.currentRowIndex);
            $scope.originalCollection = arrayCopy(vm.rowCollection);
        };

        $scope.$watch('data', function (data, old) { // This handler for initialize data.
            vm.data = arrayCopy($scope.data);
            vm.originalData = arrayCopy($scope.data);
            var newTotal = data != null ? data.length : 0;
            if (infiniteScrollLoadsize == 0) {
                $scope.rowCollection = vm.data;
                $scope.originalCollection = arrayCopy($scope.rowCollection);
            } else {
                if ($scope.rowCollection.length == 0 || $scope.total != newTotal) {
                    $scope.total = newTotal;
                    $scope.currentRowIndex = 0;
                    $scope.rowCollection = getAPage();
                    $scope.originalCollection = arrayCopy($scope.rowCollection);

                    $timeout(function () { //scroll a bit up
                        var gridBody = angular.element('#' + folderContent.gridDocuments + ' tbody')[0];
                        var scrollTop = gridBody.scrollTop;
                        gridBody.scrollTop -= scrollTop / 2;
                    }, 10, false);
                }
            }
        }, true);

        $scope.$on(broadcastType.gridDataChanges, function (e, target) {
            if (target.id != $scope.identifier) return;

            var newTotal = target.data != null ? target.data.length : 0;
            if (infiniteScrollLoadsize == 0) {
                $scope.rowCollection = target.data;
                $scope.originalCollection = arrayCopy($scope.rowCollection);
                return;
            }

            if ($scope.rowCollection.length == 0 || $scope.total != newTotal || target.isForced) {
                $scope.total = newTotal;
                $scope.currentRowIndex = 0;
                vm.data = target.data;
                $scope.rowCollection = getAPage();
                $scope.originalCollection = arrayCopy($scope.rowCollection);

                $timeout(function () { //scroll a bit up
                    var gridBody = angular.element('#' + folderContent.gridDocuments + ' tbody')[0];
                    var scrollTop = gridBody.scrollTop;
                    gridBody.scrollTop -= scrollTop / 2;
                }, 10, false);
            }
        });

        $scope.$on($scope.gridSettingKey, function (e, target) {
            getSettingGridColumn();
        });

        function showAllDocuments() {
            $scope.rowCollection = vm.data;
            $scope.originalCollection = arrayCopy($scope.rowCollection);
            $scope.currentRowIndex = $scope.total;
        }

        function getAPage() {
            var data = [];
            var startIndex = $scope.currentRowIndex;
            var endIndex = startIndex + infiniteScrollLoadsize;
            for (var i = startIndex; i < endIndex; i++) {
                if ($scope.currentRowIndex < $scope.total) {
                    data.push(vm.data[i]);
                    $scope.currentRowIndex += 1;
                } else {
                    break;
                }
            }
            return data;
        }

        function onRowClick(row) {
            $scope.onRowClick({ id: row.id, isProcess: row.isProcess, version: row.version, row: row });
        };

        function selectRow(e, row) {
            e.stopPropagation();
        }

        function calculateColumnsWidth(numColumns, extraWidth) {

            var __numCoumns = numColumns == null ? 0 : numColumns;
            var __extraWidth = extraWidth == null ? 0 : extraWidth;
            var additionWidth = 0;
            if (__numCoumns > 0) {
                additionWidth = (__extraWidth / __numCoumns);
            }
            var temp = [];
            angular.copy(vm.columnsDefinition, temp);
            var ratio100 = 100;
            var columns = 0;
            var index = -1;
            for (var i = 0; i < vm.columnsDefinition.length; i++) {
                var column = vm.columnsDefinition[i];
                if (column.coldefault && column.id != $scope.columnNotRemove) {
                    if (String(column.width).indexOf('px') <= 0) {
                        var ratio = additionWidth + parseInt(column.width);
                        ratio100 = ratio100 - ratio;
                        temp[i].width = ratio + '%';
                        columns += 1;
                    }
                } else if (column.id == $scope.columnNotRemove) {
                    index = i;
                }
            }
            if (index != -1) {
                if (ratio100 < 3) {
                    temp[index].width = "100px";
                } else {
                    temp[index].width = ratio100 + "%";
                }
            }
            if (ratio100 > 51 && ratio100 != 100) {
                temp = calculateColumnsWidth(columns, (ratio100 - 50));
            }

            return temp;
        }

        $scope.$watch('gridSetting', function (newData, oldData) {
            if (newData != null && newData != oldData) {
                getSettingGridColumn();
            }
        });
        
        function arrayCopy(data) {
            if (data && data.length > 0) {
                return data.slice();
            }
        };
    };
})();